import { Component, EventEmitter, Input, Output } from '@angular/core';

import { StepperStep } from './interfaces';

@Component({
  selector: 'fcom-stepper',
  styleUrls: ['./stepper.component.scss'],
  templateUrl: './stepper.component.html',
})
export class StepperComponent {
  @Input()
  showLabels = true;

  @Input()
  steps: StepperStep[] = [];

  @Input()
  activeStep = 0;

  @Input()
  darkMode = false;

  @Output()
  clicked: EventEmitter<StepperStep> = new EventEmitter<StepperStep>();
}
